import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { Home, Clapperboard, Mic, Users, Palette, FolderOpen, Download, Sparkles, PenLine, Puzzle } from "lucide-react";

export const STUDIO_NAV = [
  { to: "/media", end: true, label: "Overview", icon: Home, id: "overview" },
  { to: "/media/ai", label: "AI Video Maker", icon: Sparkles, id: "ai" },
  { to: "/media/scripts", label: "Script Writer", icon: PenLine, id: "scripts" },
  { to: "/media/plugins", label: "Plugins", icon: Puzzle, id: "plugins" },
  { to: "/media/video", label: "Video Studio", icon: Clapperboard, id: "video" },
  { to: "/media/audio", label: "Audio Studio", icon: Mic, id: "audio" },
  { to: "/media/team", label: "Production Team", icon: Users, id: "team" },
  { to: "/media/brand", label: "Brand Library", icon: Palette, id: "brand" },
  { to: "/media/projects", label: "My Projects", icon: FolderOpen, id: "projects" },
  { to: "/media/exports", label: "Exports", icon: Download, id: "exports" },
];

export default function MediaLayout() {
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => setOpen(false), [loc.pathname]);
  const link = ({ isActive }) => `flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors ${isActive ? "bg-[#1a2234] text-white" : "text-slate-400 hover:text-white hover:bg-[#131722]"}`;
  return (
    <div className="min-h-screen bg-[#05070c] text-slate-100" data-testid="media-layout">
      <div className="border-b border-slate-800/80 bg-[#0B0D12]/90 backdrop-blur sticky top-0 z-30">
        <div className="max-w-[1400px] mx-auto px-4 h-12 flex items-center gap-4">
          <Link to="/media" className="font-display font-extrabold tracking-tight text-sm"><span className="text-white">MY VELOCITY</span> <span className="text-cyan-300">Media Maker</span></Link>
          <nav className="hidden md:flex items-center gap-1 ml-4 text-sm"><NavLink to="/community" className="px-3 py-1.5 text-slate-400 hover:text-white">Community</NavLink><NavLink to="/media" end className={({ isActive }) => `px-3 py-1.5 border-b-2 ${isActive ? "border-blue-500 text-white" : "border-transparent text-slate-400 hover:text-white"}`}>Media Maker</NavLink><NavLink to="/media/projects" className={({ isActive }) => `px-3 py-1.5 border-b-2 ${isActive ? "border-blue-500 text-white" : "border-transparent text-slate-400 hover:text-white"}`}>My Projects</NavLink></nav>
          <button onClick={() => setOpen(!open)} className="md:hidden ml-auto text-xs text-slate-300 border border-slate-700 rounded-md px-2 py-1" data-testid="media-nav-toggle">Studio</button>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-4 py-5 grid md:grid-cols-[200px_1fr] gap-5">
        <aside className={`${open ? "block" : "hidden"} md:block`} data-testid="media-sidenav">
          <p className="font-mono text-[10px] tracking-[0.25em] text-slate-500 px-3 mb-2">STUDIO</p>
          <nav className="space-y-0.5">{STUDIO_NAV.map((n) => <NavLink key={n.id} to={n.to} end={n.end} className={link} data-testid={`media-nav-${n.id}`}><n.icon className="w-4 h-4" />{n.label}</NavLink>)}</nav>
          <p className="text-[10px] text-slate-600 px-3 mt-6">Concept preview · Production tools and team services require setup.</p>
        </aside>
        <main className="min-w-0"><Outlet /></main>
      </div>
    </div>
  );
}
